import React from 'react';
import { Box, Typography, LinearProgress } from '@mui/material';
import { T } from '../../theme/tokens';

interface SynMetricProps {
    label:       string;
    value:       string | number;
    sub?:        string;
    color?:      string;
    progress?:   number;
    icon?:       React.ReactNode;
    dark?:       boolean;
}

export function SynMetric({ label, value, sub, color, progress, icon, dark = false }: SynMetricProps) {
    const textPrimary = dark ? '#fff' : T.color.text.primary;
    const textMuted   = dark ? 'rgba(255,255,255,0.55)' : T.color.text.muted;
    const accentColor = color ?? T.color.teal[500];

    return (
        <Box>
            <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', mb: 0.5 }}>
                <Typography sx={{ fontSize: '0.70rem', fontWeight: 600, color: textMuted, textTransform: 'uppercase', letterSpacing: '0.08em' }}>
                    {label}
                </Typography>
                {icon && <Box sx={{ color: accentColor, opacity: 0.7 }}>{icon}</Box>}
            </Box>
            <Typography sx={{ fontSize: '1.65rem', fontWeight: 800, color: textPrimary, letterSpacing: '-0.02em', lineHeight: 1.1 }}>
                {value}
            </Typography>
            {sub && (
                <Typography sx={{ fontSize: '0.72rem', color: textMuted, mt: 0.4 }}>
                    {sub}
                </Typography>
            )}
            {progress !== undefined && (
                <LinearProgress
                    variant="determinate"
                    value={progress * 100}
                    sx={{
                        mt: 1.25,
                        height: 5,
                        borderRadius: `${T.radius.full}px`,
                        backgroundColor: dark ? 'rgba(255,255,255,0.12)' : 'rgba(10,42,56,0.08)',
                        '& .MuiLinearProgress-bar': { backgroundColor: accentColor },
                    }}
                />
            )}
        </Box>
    );
}
